<p class="search-host--title" translate="search-page.kind-of-play"></p>
<p class="search-host--subtitle" translate="search-page.tours-and-activities"></p>

<div class="search--list">
  <activities></activities>
</div>

<p class="search-host--more-action" (click)="actionClicked.emit('thingstodo')"><em>{{ 'search-page.more-activities' | translate }}</em></p>
